<div class="modal-grid">
    <div class="left-column">
        <ng-content select="[left-column]"></ng-content>
    </div>
    <div class="right-column">
        <ng-content select="[right-column]"></ng-content>
    </div>
</div>
